export default {"productsSlider":"ZKtVd","title":"g-8dk","more":"bP9a-","header":"QNhkP","footer":"Lz1xy","products":"feUBK","slideItem":"KWsl7"};